import { schema } from 'normalizr'

const tableOrderItem = new schema.Entity('tableOrderItems')

export default tableOrderItem
